import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ViaCepService {

  constructor(
    private http: HttpClient
  ) { }

  getLocation(cep: string): Observable<any> {
    if (cep) {
      cep = cep.replace(/[^0-9]/gmi, '');
      const url = `//viacep.com.br/ws/${cep}/json/`;
      return this.http.get(url);
    } else {
      return of(null); // ou outro valor apropriado
    }
  }

}
